import React, { useEffect, useState } from "react";
import axios from "axios";

const PreviewOrderModal = ({ isPreviewModalOpen, togglePreviewModal, selectedOrder, fetchOrders }) => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [products, setProducts] = useState([]); // State for products

  useEffect(() => {
    if (selectedOrder) {
      fetchOrderDetails(selectedOrder.order_id);
    }
  }, [selectedOrder]);

  const fetchOrderDetails = async (orderId) => {
    try {
      const response = await axios.get(`https://api.theonlysale.com/api/order/get/${orderId}`);
      console.log("Responsi", response.data);
      if (response.status === 200) {
        setOrderDetails(response.data);
        setProducts(response.data.product || []); // Set products state
      } else {
        console.error("Failed to fetch order details");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  };

  console.log(orderDetails, products); 

  return (
    <>
      {isPreviewModalOpen && orderDetails && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50">
          <div className="relative w-full max-w-2xl p-6 max-h-full">
            <div className="relative p-6 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-8">
              <div className="flex justify-between items-center pb-4 mb-4 border-b dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Preview Order
                </h3>
                <button
                  type="button"
                  onClick={togglePreviewModal}
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <i className="fa fa-times w-5 h-5"></i>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Order ID
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.order_id}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Customer Name
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.name}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Email
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.email}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Phone
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.phone}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Address
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.address}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    City
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.city}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Postal Code
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.postalCode}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Status
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">{orderDetails.status}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Total Amount
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">${orderDetails.totalAmount.toFixed(2)}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
                    Order Date
                  </label>
                  <p className="text-gray-700 dark:text-gray-300">
                    {new Date(orderDetails.createdAt).toLocaleDateString()}
                  </p>
                </div>

                <div className="md:col-span-2">
  <label className="block text-sm font-medium text-gray-900 dark:text-white mb-1">
    Products
  </label>
  {orderDetails.product && orderDetails.product.length > 0 ? (
    <div className="flex flex-wrap gap-4">
      {orderDetails.product.map((product) => (
        <div
          key={product.id}
          className="p-4 bg-gray-100 dark:bg-gray-700 rounded-lg flex-shrink-0 w-48"
        >
          <div className="font-medium text-gray-800 dark:text-white">{product.name}</div>
          <div className="text-sm text-gray-600 dark:text-gray-300">
            <p>Price: ${product.price.toFixed(2)}</p>
            <p>Details: {product.details}</p>
            <p>Quantity: {product.OrderProduct.quantity}</p>

          </div>
          {product.images && (
            <img
              src={`https://api.theonlysale.com/${JSON.parse(product.images)[0]}`}
              alt={product.name}
              className="w-24 h-24 mt-2 rounded"
            />
          )}
        </div>
      ))}
    </div>
  ) : (
    <p className="text-gray-700 dark:text-gray-300">No products available for this order.</p>
  )}
</div>


              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewOrderModal;
